import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useBranding } from "@/lib/branding";
import { ArrowLeft, Printer, Lock } from "lucide-react";

export default function Course1120Certificate() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const branding = useBranding();

  useEffect(() => {
    api.get("/course1120/certificate/status")
      .then(r => setStatus(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div className="max-w-3xl mx-auto px-6 py-14 text-muted-foreground">Loading…</div></Layout>;

  if (!status?.passed) {
    return (
      <Layout>
        <div className="max-w-2xl mx-auto px-6 py-14 text-center space-y-5" data-testid="cert-1120-locked">
          <Lock size={48} className="mx-auto text-primary" />
          <div className="font-serif text-4xl">Not yet</div>
          <p className="text-muted-foreground">Pass the 1120 final exam (80% or higher) to unlock your certificate.</p>
          <Button asChild><Link to="/course/1120/exam">Take the exam</Link></Button>
        </div>
      </Layout>
    );
  }

  const passedDate = status.passed_at ? new Date(status.passed_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "";
  const brand = branding?.brand_name || "DyNamic Tax";

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12" data-testid="cert-1120-page">
        <div className="flex justify-between items-center mb-6 print:hidden">
          <Link to="/course/1120" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground">
            <ArrowLeft size={12} /> Back to course
          </Link>
          <Button onClick={() => window.print()} size="sm" data-testid="cert-1120-print">
            <Printer size={14} className="mr-1" /> Print / Save as PDF
          </Button>
        </div>

        <div className="border-4 border-primary p-10 md:p-16 bg-white text-center space-y-6 print:border-primary" data-testid="cert-1120-body">
          <div className="text-xs uppercase tracking-[0.3em] text-primary">{brand} — Corporate Track</div>
          <div className="font-serif text-4xl md:text-5xl">Certificate of Completion</div>
          <div className="text-sm text-muted-foreground italic">This is to certify that</div>
          <div className="font-serif text-3xl md:text-4xl text-primary border-b-2 border-primary inline-block pb-1 px-8">
            {status.student_name}
          </div>
          <div className="text-sm text-muted-foreground">has successfully completed</div>
          <div className="font-serif text-2xl md:text-3xl">Mastering Form 1120 for Preparers</div>
          <div className="text-sm text-muted-foreground max-w-lg mx-auto">
            13 chapters covering every line of Form 1120, Schedules L, M-1, M-2, DRD, depreciation, PHC and Accumulated Earnings, plus 13 realistic C-corporation practice returns and a 20-question final exam.
          </div>
          <div className="pt-8 grid grid-cols-2 gap-8 max-w-lg mx-auto text-xs">
            <div>
              <div className="border-t border-foreground pt-1">Date awarded</div>
              <div className="mt-1">{passedDate}</div>
            </div>
            <div>
              <div className="border-t border-foreground pt-1">Signed</div>
              <div className="mt-1">Di'Meka Skinner-Hairston · {brand}</div>
            </div>
          </div>
          <div className="text-[9px] uppercase tracking-[0.3em] text-muted-foreground pt-4">
            Powered by <span className="font-serif italic normal-case tracking-normal">{brand}</span>
          </div>
        </div>
      </div>
    </Layout>
  );
}
